export enum ApplicationProperty {
    FirstName = 1,
    LastName = 2,
    DateOfBirth = 3,
    School = 4,
    Email = 5,
    Grade = 6,
    Address = 7,
    City = 8,
    State = 9,
    ZipCode = 10,
    Gender = 11,
    Ethnicity = 12,
    PhoneNumber = 13,
    Race = 14,
    FosterCare = 15,
    Homeless = 16,
    Parent1_FirstName = 17,
    Parent1_LastName = 18,
    Parent1_Relationship = 19,
    Parent1_CellPhoneNumber = 20,
    Parent1_Email = 21,
    Parent1_Address = 22,
    Parent1_City = 23,
    Parent1_State = 24,
    Parent1_ZipCode = 25,
    Parent1_AddressSameAsStudent = 26,
    Parent2_FirstName = 27,
    Parent2_LastName = 28,
    Parent2_Relationship = 29,
    Parent2_CellPhoneNumber = 30,
    Parent2_Email = 31,
    Parent2_Address = 32,
    Parent2_City = 33,
    Parent2_State = 34,
    Parent2_ZipCode = 35,
    Parent2_AddressSameAsStudent = 36,
    Parent1_HomePhoneNumber = 37,
    Parent2_HomePhoneNumber = 38,
    FirstGeneration = 39,
    GraduationYear = 40,
    CustomStudentProperty = 41,
    Parent1_HighestCompletedEducation = 42,
    Parent2_HighestCompletedEducation = 43,
    StudentID = 44,
    MiddleName = 45,
    CellPhone = 46,
    IdType2 = 47,
    IdType3 = 48,
    IdType4 = 49,
    Program = 50
}